import type {
  InjectionKey,
  Ref,
} from 'vue'
import type { SideMenuDisplayMode } from '@/constants/enums/SideMenuDisplayMode'

export const sideMenuDisplayModeInjectionKey = Symbol(
  'SideMenuDisplayModeInjectionKey',
) as InjectionKey<Ref<SideMenuDisplayMode>>
